import { isApiError, reportClientError } from '@instanexus/sdk';
import { useEffect, type ReactElement } from 'react';
import { useRouteError } from 'react-router';

import { ErrorFallback } from '@/components/error-fallback';

/**
 * The router's `errorElement`: React Router catches a routed page's render crash itself and
 * would otherwise show its own default error screen. Same fallback as the app-level boundary.
 */
export function RouteErrorFallback(): ReactElement {
  const error = useRouteError();

  useEffect(() => {
    reportClientError({
      source: 'render',
      message: 'Unhandled render error caught by the route error element',
      requestId: isApiError(error) ? error.requestId : undefined,
      cause: error,
    });
  }, [error]);

  return (
    <ErrorFallback
      requestId={isApiError(error) ? error.requestId : undefined}
      onReset={() => {
        window.location.reload();
      }}
    />
  );
}
